module.exports = __webpack_public_path__ + "img/ZJ5281.f30c44af.png";